import { StarRemoveIcon } from './StarRemoveIcon';

/**
 * author: Michael Irigoyen
 * id 49254980-CD72-42B5-A87B-F24EFC2E4EA5
 * name star-remove
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-remove.svg
 * tags
 * - Shape 
 */
export const FavoriteRemoveIcon = StarRemoveIcon;
export default FavoriteRemoveIcon